import { IUserRole, ITeamFilters } from 'wisestep-api';

import { IBreadCrumbsList } from '../../../components/WsBreadCrumbs';

export const teamSettingsDefaultValues = {
  jobShareNotificationTo: [''],
  jobClosedNotificationTo: [''],
  jobInsightUpdateNotificationTo: [''],
  candidateSubmissionNotificationTo: [''],
  candidateStatusUpdateNotificationTo: [''],
  disableJobShareNotificationTo: [''],
  disableJobClosedNotificationTo: [''],
  disableJobInsightUpdateNotificationTo: [''],
  disableCandidateSubmissionNotificationTo: [''],
  disableCandidateStatusUpdateNotificationTo: [''],
};

export const invitesSearchDefaultValues = {
  invitesSearch: '',
};

export const defaultTeamName = {
  teamName: '',
};

export const inviteDefaultValues = {
  invitedUsers: [],
  role: IUserRole.RECRUITER,
  downloadAccess: false,
};

export const teamFilters: ITeamFilters = {
  pageNumber: 1,
  pageSize: 10,
  searchKeyword: '',
  workspaceId: '',
};

export enum ISettingBreadCrumbTypes {
  TEAMS_AND_USERS = 'teams-and-users',
  JOBS = 'jobs',
  ANALYTICS = 'analytics',
  CRM = 'crm',
  CAREER_PAGES = 'career-pages',
  ACCOUNT = 'account',
  PLACEMENTS = 'placements',
  HELP_AND_KNOWLEDGE = 'help-and-knowledge',
  APPS_AND_INTEGRATION = 'apps-and-integrations',
  INVOICE = 'invoice-module',
  CLIENTS = 'clients',
  DATA_PRIVACY = 'data-privacy',
  CRM_JOB = 'crm-job',
  AUTOMATION = 'automation',
  CRM_JOBS = 'crm-jobs',
}

export type CurrentPageType =
  | 'TEAMS'
  | 'USERS'
  | 'DATA_DOWNLOAD'
  | 'DATA_SHARING'
  | 'JOB_ATTRIBUTE_SETTING'
  | 'JOB_DATA_DOWNLOAD_SETTING'
  | 'CLOSE_JOB'
  | 'JOB_ADMIN_SETTING'
  | 'JOB_ATTRIBUTE_VISIBILITY_SETTING'
  | 'ANALYTICS_SETTINGS'
  | 'MAPPING_FORM'
  | 'SUBMISSION_FORM_TEMPLATES'
  | 'MANAGE_RECRUITER_ACTIONS'
  | 'MANAGE_CANDIDATE_RESPONSE'
  | 'DATA_DOWNLOAD_SETTING'
  | 'PAGINATION_SETTINGS'
  | 'CURRENCIES'
  | 'UPLOADED_LOGOS'
  | 'EVALUTION_TEMPLATES'
  | 'INFORMATION_CATAGORIES'
  | 'RTR_TEMPLATE'
  | 'NOTIFICATION_SETTINGS'
  | 'FREQUENTLY_ASKED_QUESTIONS'
  | 'TALENT_MAGNET_SETTINGS'
  | 'CAREER_PAGE_SETTINS'
  | 'JOB_BOARD_CONFIGURATION'
  | 'COMMUNICATION_ACCOUNT_CONFIGURATION'
  | 'NATIVE_SEARCH_CONFIGURATION'
  | 'EMAIL_SETTINGS'
  | 'TEMPLATE_SETTINGS'
  | 'CV_UPLOADER_APP'
  | 'RESUME_PARSING_BY_EMAIL'
  | 'PROMPT_SETTINGS'
  | 'PRISM_SETTINGS'
  | 'CALENDER'
  | 'VMS_INTEGRATION'
  | 'PLACEMENT_STATUS'
  | 'PLACEMENT_ORIGIN'
  | 'PLACEMENT_STAGE'
  | 'CUSTOMIZE_PLACEMENT_FIELDS'
  | 'CONTRACT_REVENUE_CALCULATOR'
  | 'PAYMENT_TYPE'
  | 'TAX_TYPE'
  | 'INVOICE_TYPE'
  | 'INVOICE_EXTRA'
  | 'CUSTOMIZE_INVOICE_FIELDS'
  | 'TERMS_AND_CONDITIONS'
  | 'CLIENTS_STATUS'
  | 'CURRENCY_DETAILS'
  | 'FILE_CATAGORIES'
  | 'LEGAL_IDENTIFIERS'
  | 'FEE_ARRANGEMENT_LEVELS'
  | 'CUSTOMIZE_CLIENT_FIELDS'
  | 'CUSTOMIZE_CONTACT_FIELDS'
  | 'DATA_PROTECTION_SET_UP'
  | 'DELETE_REQUESTS'
  | 'ACCESS_CONTROL_SETTINGS'
  | 'ATS_ACCESS'
  | 'USER_ACCESS'
  | 'TEAMS_ACCESS'
  | 'JOBS_ACCESS'
  | 'CANDIDATE_ACCESS'
  | 'NATIVE_SEARCH_ACEESS'
  | 'PREMIUM_JOB_BOARDS_ACCESS'
  | 'VMS_ACCESS'
  | 'SMS_ACCESS'
  | 'ATTRIBUTE_VISIBILITY'
  | 'COMPOSSABLE_ANALYTICS_ACCESS'
  | 'CLIENT_LISTING_ACCESS'
  | 'INVOICING_AND_PLACEMENT_ACCESS'
  | 'ORGANIZATION_ENTITY_ACCESS'
  | 'ORGANIZATIONAL_UNITS'
  | 'BUSINESS_UNITS'
  | 'LEADS_FROM_EMAIL'
  | 'NOTES_FROM_EMAIL'
  | 'DEFAULT_AUTOMATED_EMAIL_CAMPAIGN'
  | 'JOB_AUTOMATED_EMAIL_CAMPAIGN'
  | 'CLIENT_AUTOMATED_EMAIL_CAMPAIGN'
  | 'CLIENT_SPOC_AUTOMATED_EMAIL_CAMPAIGN'
  | 'SOURCE_AUTOMATED_EMAIL_CAMPAIGN'
  | 'ADD_NEW_AUTOMATED_EMAIL_CAMPAIGN'
  | 'CRM_JOB_SETTINGS'
  | 'CRM_JOB_ACCESS'
  | 'AUTOMATION'
  | 'ADD_NEW_AUTOMATION'
  | 'EDIT_AUTOMATION'
  | 'CRM_JOBS_STATUS'
  | 'LEAD_ACCESS'
  | 'CLIENT_CONTACTS_ACCESS';

export const Pages: Record<CurrentPageType, IBreadCrumbsList> = {
  TEAMS: { label: 'Teams', url: '/teams' },
  USERS: { label: 'Users', url: '/users' },
  DATA_DOWNLOAD: { label: 'Data Download', url: '/data-download' },
  DATA_SHARING: { label: 'Data Sharing', url: '/data-sharing' },
  JOB_ATTRIBUTE_SETTING: { label: 'Job Attribute Settings', url: '/job-fields-settings' },
  JOB_DATA_DOWNLOAD_SETTING: {
    label: "Job's Data Download Settings",
    url: '/jobs-download-settings',
  },
  CLOSE_JOB: {
    label: 'Reasons for closing Job',
    url: '/close-job-reason',
  },
  JOB_ADMIN_SETTING: {
    label: 'Job Admin Settings',
    url: '/job-posting-settings',
  },
  JOB_ATTRIBUTE_VISIBILITY_SETTING: {
    label: 'Job Attribute Visibility Settings',
    url: '/job-attribute-visibility-setting',
  },
  ANALYTICS_SETTINGS: {
    label: 'Analytics Settings',
    url: '/analytics-settings',
  },
  MAPPING_FORM: {
    label: 'Mapping Form',
    url: '/crm-settings/configure-mapping-form',
  },
  SUBMISSION_FORM_TEMPLATES: {
    label: 'Configure Submission Flow',
    url: '/crm-settings/configure-submission-flow',
  },
  MANAGE_RECRUITER_ACTIONS: {
    label: 'Manage Actions',
    url: '/candidate-interaction-messaging/',
  },
  MANAGE_CANDIDATE_RESPONSE: {
    label: 'Manage Candidate Response',
    url: '/candidate-interaction-result-pipeline',
  },
  DATA_DOWNLOAD_SETTING: {
    label: 'Data Download Settings',
    url: '/download-settings/data-download',
  },
  PAGINATION_SETTINGS: {
    label: 'Pagination Settings',
    url: '/pagination-settings',
  },
  CURRENCIES: {
    label: 'CURRENCIES',
    url: '/currencies',
  },
  UPLOADED_LOGOS: {
    label: 'Uploaded Logos',
    url: '/workspace-settings/organization-logo',
  },
  EVALUTION_TEMPLATES: {
    label: 'Evalution Template List',
    url: '/evaluation-template',
  },
  INFORMATION_CATAGORIES: {
    label: 'Information Catagories',
    url: '/information-categories',
  },
  RTR_TEMPLATE: {
    label: 'RTR Template',
    url: '/rtr-template',
  },
  NOTIFICATION_SETTINGS: {
    label: 'Notification Settings',
    url: '/notification-settings',
  },
  FREQUENTLY_ASKED_QUESTIONS: {
    label: 'Frequently Asked Questions',
    url: '/help-and-knowledge/faq',
  },
  TALENT_MAGNET_SETTINGS: {
    label: 'Talent Magnet Settings',
    url: '/app-settings/cv-upload-settings/appearance',
  },
  CAREER_PAGE_SETTINS: {
    label: 'Career Page Settings',
    url: '/app-settings/career-page/general',
  },
  JOB_BOARD_CONFIGURATION: {
    label: 'Job Board Configuration',
    url: '/job-boards',
  },
  COMMUNICATION_ACCOUNT_CONFIGURATION: {
    label: 'Communication Account Configuration',
    url: '/sms-configuration',
  },
  NATIVE_SEARCH_CONFIGURATION: {
    label: 'Native Search Configuration',
    url: '/native-search-settings/',
  },
  EMAIL_SETTINGS: {
    label: 'Email Settings',
    url: '/email-settings/',
  },
  TEMPLATE_SETTINGS: {
    label: 'Template Settings',
    url: '/template-settings/email-template-settings',
  },
  CV_UPLOADER_APP: {
    label: 'CV Uploader App',
    url: '/bulk-importer',
  },
  RESUME_PARSING_BY_EMAIL: {
    label: 'Resume Parsing by Email',
    url: '/resume-parsing-by-email/',
  },
  NOTES_FROM_EMAIL: {
    label: 'Notes From Email',
    url: '/notes-email/',
  },
  LEADS_FROM_EMAIL: {
    label: 'Leads From Email',
    url: '/notes-email/',
  },
  PROMPT_SETTINGS: {
    label: 'Prompt Setting',
    url: '/prompt-settings/',
  },
  PRISM_SETTINGS: {
    label: 'Prism Settings',
    url: '/prism-extension-settings/',
  },
  CALENDER: {
    label: 'Calender',
    url: '/calender-settings',
  },
  VMS_INTEGRATION: {
    label: 'VMS Integration',
    url: '/vms',
  },
  PLACEMENT_STATUS: {
    label: 'Placement Status',
    url: '/placements/settings/placement_status',
  },
  PLACEMENT_ORIGIN: {
    label: 'Placement Origin',
    url: '/placements/settings/placement_origin',
  },
  PLACEMENT_STAGE: {
    label: 'Placement Stage',
    url: '/placements/settings/placement_stage',
  },
  CUSTOMIZE_PLACEMENT_FIELDS: {
    label: 'Customize Placement Fields',
    url: '/app-settings/customize-placement-fields',
  },
  CONTRACT_REVENUE_CALCULATOR: {
    label: 'Contract Revenue Calculator',
    url: '/placements/settings/contract_revenue_calculator',
  },
  PAYMENT_TYPE: {
    label: 'Payment Type',
    url: '/invoice/settings/payment_type',
  },
  TAX_TYPE: {
    label: 'Tax Type',
    url: '/invoice/settings/tax_type',
  },
  INVOICE_TYPE: {
    label: 'Invoice Type',
    url: '/invoice/settings/invoice_type',
  },
  INVOICE_EXTRA: {
    label: 'Invoice Extra',
    url: '/invoice/settings/invoice_extra',
  },
  CUSTOMIZE_INVOICE_FIELDS: {
    label: 'Customize Invoice Fields',
    url: '/invoice/settings/customize-invoice-fields',
  },
  TERMS_AND_CONDITIONS: {
    label: 'Terms And Conditions',
    url: '/invoice/settings/terms-and-conditions',
  },
  CLIENTS_STATUS: {
    label: 'Client Status',
    url: '/clients/client-status',
  },
  CURRENCY_DETAILS: {
    label: 'Currency Details',
    url: '/currencies',
  },
  FILE_CATAGORIES: {
    label: 'File Catagories',
    url: '/app-settings/file_categories',
  },
  LEGAL_IDENTIFIERS: {
    label: 'Legal Identifiers',
    url: '/legal_identifiers',
  },
  FEE_ARRANGEMENT_LEVELS: {
    label: 'Fee Arrangement Levels',
    url: '/position_levels',
  },
  CUSTOMIZE_CLIENT_FIELDS: {
    label: 'Customize Client Fields',
    url: '/app-settings/customize-client-fields',
  },
  CUSTOMIZE_CONTACT_FIELDS: {
    label: 'Customize Contact Fields',
    url: '/app-settings/customize-contact-fields',
  },
  DATA_PROTECTION_SET_UP: {
    label: 'Data Protection And Privacy Settings',
    url: '/setup',
  },
  DELETE_REQUESTS: {
    label: 'Delete Requests',
    url: '/delete-requests/',
  },
  ACCESS_CONTROL_SETTINGS: {
    label: 'Access Control Settings',
    url: '/access-control',
  },
  ATS_ACCESS: {
    label: 'ATS Access Control',
    url: '/ats-access-control/',
  },
  USER_ACCESS: {
    label: 'Users Access',
    url: '/users-access-control/',
  },
  TEAMS_ACCESS: {
    label: 'Teams Access',
    url: '/teams-access-control/',
  },
  JOBS_ACCESS: {
    label: 'Jobs Access',
    url: '/jobs-access-control',
  },
  CANDIDATE_ACCESS: {
    label: 'Candidate Access',
    url: '/candidate-access-control',
  },
  NATIVE_SEARCH_ACEESS: {
    label: 'Native Search Access Control',
    url: '/native-search-access-control',
  },
  PREMIUM_JOB_BOARDS_ACCESS: {
    label: 'Premium Job Board Access',
    url: '/premium-job-access-control',
  },
  VMS_ACCESS: {
    label: 'VMS Configuration',
    url: '/vms-access-control/',
  },
  SMS_ACCESS: {
    label: 'SMS Configuration',
    url: '/sms-access-control/',
  },
  ATTRIBUTE_VISIBILITY: {
    label: 'Attribute Visibility',
    url: '/access-control',
  },
  COMPOSSABLE_ANALYTICS_ACCESS: {
    label: 'Composable Analytics Access Control',
    url: '/analytics-data-access-control/',
  },
  CLIENT_LISTING_ACCESS: {
    label: 'Client Listing Access Control',
    url: '/client-listing-access-control',
  },
  INVOICING_AND_PLACEMENT_ACCESS: {
    label: 'Invoicing and Placement Access Control',
    url: '/invoicing-closure-access-control',
  },
  ORGANIZATION_ENTITY_ACCESS: {
    label: 'Organization Entity Access Control',
    url: '/entity-access-control',
  },
  LEAD_ACCESS: {
    label: 'Lead Access Control',
    url: '/lead-access-control/',
  },
  CRM_JOB_ACCESS: {
    label: 'CRM Jobs Access Control',
    url: '/crm-jobs-access-control/',
  },
  CLIENT_CONTACTS_ACCESS: {
    label: 'Client Contacts Access Control',
    url: '/client-contacts-access-control/',
  },
  ORGANIZATIONAL_UNITS: {
    label: 'Organizational Units',
    url: '/organizational_unit',
  },
  BUSINESS_UNITS: {
    label: 'Business Units',
    url: '/business_unit',
  },
  DEFAULT_AUTOMATED_EMAIL_CAMPAIGN: {
    label: 'Automated Email Campaign Settings',
    url: '/automated-email-campaign-settings/',
  },
  SOURCE_AUTOMATED_EMAIL_CAMPAIGN: {
    label: 'Automated Email Campaign Settings',
    url: '/automated-email-campaign-settings/source',
  },
  JOB_AUTOMATED_EMAIL_CAMPAIGN: {
    label: 'Automated Email Campaign Settings',
    url: '/automated-email-campaign-settings/job',
  },
  CLIENT_AUTOMATED_EMAIL_CAMPAIGN: {
    label: 'Automated Email Campaign Settings',
    url: '/automated-email-campaign-settings/client',
  },
  CLIENT_SPOC_AUTOMATED_EMAIL_CAMPAIGN: {
    label: 'Automated Email Campaign Settings',
    url: '/automated-email-campaign-settings/client-spoc',
  },
  ADD_NEW_AUTOMATED_EMAIL_CAMPAIGN: {
    label: 'Add Email Campaign',
    url: '/automated-email-campaign-settings/add-new-campaign?type=client',
  },
  ADD_NEW_AUTOMATION: {
    label: 'Add New Automation',
    url: '/automation/add-new-automation',
  },
  CRM_JOB_SETTINGS: {
    label: 'CRM Job Settings',
    url: '/crm-job-settings',
  },
  AUTOMATION: {
    label: 'Automation',
    url: '/automation',
  },
  EDIT_AUTOMATION: {
    label: 'Edit Automation',
    url: '/automation/edit',
  },
  CRM_JOBS_STATUS: {
    label: 'CRM Job Status',
    url: '/crm-job-status',
  },
};
export const getSettingBreadCrumbList = (
  type: ISettingBreadCrumbTypes,
  currentPage: IBreadCrumbsList
): IBreadCrumbsList[] => [{ label: 'Settings', url: `/app-settings/${type}` }, currentPage];

export const teamMembersBreadCrumbsList = (teamName: string): IBreadCrumbsList[] => [
  ...getSettingBreadCrumbList(ISettingBreadCrumbTypes.TEAMS_AND_USERS, Pages['TEAMS']),
  { label: teamName, url: window.location.pathname },
];

export const emailRules = [
  '1. Only PDF, DOC, DOCX, RTF, and HTML attachments are allowed',
  '2. Total Number of emails processed for a workspace is 10,000 emails per day',
  '3. Zipped files cannot be processed',
];
